import React from 'react'
import style from  "./Home.module.css"
import { Link } from 'react-router-dom';

export const Home = () => {
  return (
    <div className={style.homehero} id="home">
      <div className={style.mask}>
        <img
          className={style.into_img}
          src="https://images.unsplash.com/photo-1616400619175-5beda3a17896?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
          alt=""
        />
      </div>
      <div className={style.content}>
        <h2>
          
          <span style={{ color: "red" }}> </span>{" "}
        </h2>
        <p></p>
        <h1></h1>
        
      </div>
    </div>
  );
}
